import React from "react"
import { FiChevronDown } from "react-icons/fi"

import * as style from "./Control.module.scss"

const CloseButton = ({ explorer, microcopy }) => (
  <button
    className={style.close}
    onClick={() => explorer.disable()}
    aria-label={microcopy.text("explorer.buttons.close")}
  >
    <FiChevronDown />
  </button>
)

export default CloseButton
